import { render, staticRenderFns } from "./logDashboard.vue?vue&type=template&id=389518d7&scoped=true"
import script from "./logDashboard.vue?vue&type=script&lang=js"
export * from "./logDashboard.vue?vue&type=script&lang=js"
import style0 from "./logDashboard.vue?vue&type=style&index=0&id=389518d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389518d7",
  null
  
)

export default component.exports